import { render, staticRenderFns } from "./HistoricoPermissao.vue?vue&type=template&id=71b4efd5&scoped=true"
import script from "./HistoricoPermissao.vue?vue&type=script&lang=ts"
export * from "./HistoricoPermissao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b4efd5",
  null
  
)

export default component.exports